import styled from 'styled-components';


export const Container = styled.div`
    display: flex ;
    flex-direction: column ;
    justify-content:center ;
    align-items: center ;

    img {
        width: 180px ;
    }

    h3{
        font-weight:normal ;
        color:var(--bs-default);
    }

`